module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tiles-select"
  }, [_c('button', {
    staticClass: "none",
    on: {
      "click": function($event) {
        _vm.change('none')
      }
    }
  }, [_vm._v("Base Map")]), _vm._v(" "), _c('button', {
    staticClass: "blue",
    on: {
      "click": function($event) {
        _vm.change('bluebell')
      }
    }
  }, [_vm._v("Bluebells")]), _vm._v(" "), _c('button', {
    staticClass: "wild",
    on: {
      "click": function($event) {
        _vm.change('wildflower')
      }
    }
  }, [_vm._v("Wild Flowers")]), _vm._v(" "), _c('button', {
    staticClass: "tree",
    on: {
      "click": function($event) {
        _vm.change('tree')
      }
    }
  }, [_vm._v("Trees")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f22035e0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/custom/TileSelect.vue
// module id = 102
// module chunks = 1